var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1LaVisualColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 547.61 565.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #56af33;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ff6400;\n      }\n\n      .cls-3 {\n        fill: #ffc800;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,194.31h50.76l7.3,7.3,7.3,6.89,17.24,72.52,20.41-86.7h50.76l7.3,7.3,7.3,6.89-48.53,165.14h-56.7l-7.3-6.89-7.3-7.3L0,194.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m175.71,0h46.79l7.09,7.09,7.09,7.09v110.11h36.82l7.09,7.09,7.09,7.09v40.85h-97.8l-7.09-7.09-7.09-7.09V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.71,0h46.79l7.09,7.09v117.2h43.91l7.09,7.09v40.85h-97.8l-7.09-7.09V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.71,0h46.79v124.29h51v40.85h-97.8V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m399.51,165.14l-1.8-8.1h-31.53l-4.95,22.28h-48.28l-9.46-7.09-9.46-7.09L342.57,0h56.7l9.46,7.09,9.46,7.09,48.53,165.14h-48.28l-9.46-7.09-9.46-7.09Zm-24.42-47.96h29.46l-14.61-62.14-14.86,62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m396.13,149.95h-39.41l-4.95,22.28h-48.28l-9.46-7.09L342.57,0h56.7l9.46,7.09,48.53,165.14h-48.28l-9.46-7.09-3.38-15.19Zm-30.5-39.86h29.46l-14.61-62.14-14.86,62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m394.56,142.86h-47.29l-4.95,22.28h-48.28L342.57,0h56.7l48.53,165.14h-48.28l-4.95-22.28Zm-38.38-39.86h29.46l-14.61-62.14-14.86,62.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m176.38,385.91h46.79l7.09,7.09,7.09,7.09v110.11h36.82l7.09,7.09,7.09,7.09v40.85h-97.8l-7.09-7.09-7.09-7.09v-165.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m176.38,385.91h46.79l7.09,7.09v117.2h43.91l7.09,7.09v40.85h-97.8l-7.09-7.09v-165.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m176.38,385.91h46.79v124.29h51v40.85h-97.8v-165.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105.47,551.05l-1.8-8.1h-31.53l-4.95,22.28H18.91l-9.46-7.09-9.46-7.09,48.53-165.14h56.7l9.46,7.09,9.46,7.09,48.53,165.14h-48.28l-9.46-7.09-9.46-7.09Zm-24.42-47.96h29.46l-14.61-62.14-14.86,62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m102.09,535.86h-39.41l-4.95,22.28H9.46l-9.46-7.09,48.53-165.14h56.7l9.46,7.09,48.53,165.14h-48.28l-9.46-7.09-3.38-15.19Zm-30.5-39.86h29.46l-14.61-62.14-14.86,62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.52,528.76h-47.29l-4.95,22.28H0l48.53-165.14h56.7l48.53,165.14h-48.28l-4.95-22.28Zm-38.38-39.86h29.46l-14.61-62.14-14.86,62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,194.31h50.76l7.3,7.3,21.72,91.37,23.23-98.67h50.76l7.3,7.3-48.53,165.14h-56.7l-7.3-7.3L0,194.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,194.31h50.76l26.24,110.42,26-110.42h50.76l-48.53,165.14h-56.7L0,194.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m175.71,194.31h46.79l7.09,7.09,7.09,7.09v165.14h-46.79l-7.09-7.09-7.09-7.09v-165.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.71,194.31h46.79l7.09,7.09v165.14h-46.79l-7.09-7.09v-165.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.71,194.31h46.79v165.14h-46.79v-165.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m283.03,317.31c9.9,10.4,25.01,17.33,40.6,17.33,8.91,0,15.6-3.96,15.6-10.15,0-7.18-7.43-11.14-20.55-15.35-21.29-6.93-52.49-15.6-52.49-52.49,0-26.99,20.8-52.49,61.4-52.49,19.48,0,35.1,2,49.11,11.97,1.66,1.18,5.54,5.78,7.09,7.09l-21.29,34.66c-10.89-9.16-24.26-13.37-34.91-13.37s-13.62,4.46-13.62,9.41c0,6.93,7.18,10.4,21.05,14.86,21.29,6.93,51.5,16.84,51.5,51.25s-23.77,54.97-62.14,54.97c-28.47,0-48.28-8.17-63.14-22.04l-14.18-14.18,35.97-21.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m275.94,310.21c9.9,10.4,25.01,17.33,40.6,17.33,8.91,0,15.6-3.96,15.6-10.15,0-7.18-7.43-11.14-20.55-15.35-21.29-6.93-52.49-15.6-52.49-52.49,0-26.99,20.8-52.49,61.4-52.49,19.69,0,35.03,1.79,49.11,11.97,1.5,1.09,5.68,5.9,7.09,7.09l-21.29,34.66c-10.89-9.16-24.26-13.37-34.91-13.37s-13.62,4.46-13.62,9.41c0,6.93,7.18,10.4,21.05,14.86,21.29,6.93,51.5,16.84,51.5,51.25s-23.77,54.97-62.14,54.97c-28.47,0-48.28-8.17-63.14-22.04l-7.09-7.09,28.88-28.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m268.85,303.12c9.9,10.4,25.01,17.33,40.6,17.33,8.91,0,15.6-3.96,15.6-10.15,0-7.18-7.43-11.14-20.55-15.35-21.29-6.93-52.49-15.6-52.49-52.49,0-26.99,20.8-52.49,61.4-52.49,21.79,0,41.59,6.69,56.2,19.06l-21.29,34.66c-10.89-9.16-24.26-13.37-34.91-13.37s-13.62,4.46-13.62,9.41c0,6.93,7.18,10.4,21.05,14.86,21.29,6.93,51.5,16.84,51.5,51.25s-23.77,54.97-62.14,54.97c-28.47,0-48.28-8.17-63.14-22.04l21.79-35.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m398.49,194.31h47.29l7.09,7.09,7.09,7.09v104.98c0,13.62,6.19,22.03,20.3,22.03s20.05-8.42,20.05-22.03l-.17-119.16h33.27l7.09,7.09,7.09,7.09v104.48c0,40.11-26,63.63-67.34,63.63s-80.61-23.52-80.61-63.38l-1.16-118.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m398.49,194.31h47.29l7.09,7.09v104.98c0,13.62,6.19,22.03,20.3,22.03s20.05-8.42,20.05-22.03l.45-112.07h39.75l7.09,7.09v104.48c0,40.11-26,63.63-67.34,63.63s-74.52-23.52-74.52-63.38l-.16-111.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m398.49,194.31h47.29v104.98c0,13.62,6.19,22.03,20.3,22.03s20.05-8.42,20.05-22.03v-104.98h47.29v104.48c0,40.11-26,63.63-67.34,63.63s-67.59-23.52-67.59-63.38v-104.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1LaVisualColor);
export default __webpack_public_path__ + "static/media/1.laVisualColor.509db1d0db0fdf9a7e6cc3263ecbd9e8.svg";
export { ForwardRef as ReactComponent };